// For div element with "contenteditable=true", setup setup a hidden text area that
// will be updated with user's edited text since Blazor can't post a div
// and textarea elements don't support html formatting.
export class EditableDiv {

    // Optionally set initial content of editable div
    public static InitializeEditableDivContent(Content: string): void {
        (document.getElementById("divEditableContent") as HTMLDivElement).innerHTML = Content;
    }

    // Optionally store/retrieve editable content in browser's local storage using a key.
    public static ConnectLocalStorage(DivContentLocalStorageKey: string) {
        const divEditable: HTMLDivElement = document.getElementById("divEditableContent") as HTMLDivElement;

        // Store content whenever div loses focus
        divEditable.addEventListener("focusout", (e) => {
            localStorage.setItem(DivContentLocalStorageKey, divEditable.innerHTML); // Store inner html to local storage
        });

        // Load intial editable content from local storage
        divEditable.innerHTML = localStorage.getItem(DivContentLocalStorageKey) ?? ""; // Load from local storage
    }

    public static SetupListeners() {
        const divEditable: HTMLDivElement = document.getElementById("divEditableContent") as HTMLDivElement;
        const taTargetHidden: HTMLTextAreaElement = document.getElementById("hiddenTextAreaHTMLFromDiv") as HTMLTextAreaElement;

        // From: https://stackoverflow.com/a/1411296
        divEditable.addEventListener("focusout", (e) => {
            EditableDiv.CopyDivHTMLToTextArea(divEditable, taTargetHidden);
        });

        EditableDiv.CopyDivHTMLToTextArea(divEditable, taTargetHidden); // Copy any default/initial html to textarea

        // execCommand deprecated with no alternative: https://stackoverflow.com/a/70831583
        //document.execCommand("StyleWithCSS", false); // This fixes using "bold" in Firefox (https://stackoverflow.com/q/11966111)

        // For div element with "contenteditable=true", setup html formatting image icons (for bold, italic, etc)
        document.querySelectorAll(".ContentEditableToolbar img").forEach((elem) => elem.addEventListener('click', (evt) => {
            const img: HTMLImageElement | null = evt.currentTarget as HTMLImageElement;
            const sCmd: string = img!.dataset.commandName as string;
            if (sCmd === 'hyperlink') {
                const sLnk = prompt('Write the URL here', 'https:\/\/');
                if (sLnk && sLnk !== '' && sLnk !== 'https://') {
                    // execCommand deprecated with no alternative: https://stackoverflow.com/a/70831583
                    document.execCommand('createLink', false, sLnk);
                }
            }
            else
                // execCommand deprecated with no alternative: https://stackoverflow.com/a/70831583
                document.execCommand(sCmd, false, '');

            EditableDiv.CopyDivHTMLToTextArea(divEditable, taTargetHidden);
            divEditable.focus(); // Return focus to editable div
        }));
    }

    private static CopyDivHTMLToTextArea(divEditable: HTMLDivElement, taTargetHidden: HTMLTextAreaElement) {
        let html = divEditable.innerHTML; // Copy user's html from div to textarea for posting
        if (html === "<br>") // Some browsers will embed a <br> in an empty input (eg Firefox, Chrome)
            html = "";
        taTargetHidden.value = html; // Copy user's html from div to textarea for posting
        taTargetHidden.dispatchEvent(new Event('change', { 'bubbles': true })); // Tell Blazor that textarea changed
    }
}
